import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

import { SearchInput } from 'components/simple';

export const HeaderWithSearchInput = ({
  title = 'Manage Users',
  titleComponent = 'h1',
  searchValue,
  setSearchValue,
}) => (
  <Stack
    spacing={2}
    justifyContent="space-between"
    direction={{ xs: 'column', md: 'row' }}
    alignItems={{ xs: 'flex-start', md: 'center' }}
    mb={{ xs: 4, md: 8 }}
  >
    <Typography variant="h1" component={titleComponent}>
      {title}
    </Typography>

    <SearchInput setSearchValue={setSearchValue} searchValue={searchValue} />
  </Stack>
);

HeaderWithSearchInput.propTypes = {
  title: PropTypes.string,
  titleComponent: PropTypes.oneOf(['h1', 'h2']),
  searchValue: PropTypes.string.isRequired,
  setSearchValue: PropTypes.func.isRequired,
};
